import React from 'react';
import { Box, Grid, Typography } from '@mui/material';

import countries, { Alpha3Code } from 'i18n-iso-countries';
import { useRecordContext } from 'react-admin';
import languages from '../../../constants/languages';

export interface SustainedForeignIpCountryParams {
  lookbackPeriod: { amount: number; unit: string };
  expectedCountries: Alpha3Code[];
}

const SustainedForeignIpCountry = () => {
  const record = useRecordContext();

  if (!record) return null;

  const { lookbackPeriod, expectedCountries } = record
    .ruleParameters as SustainedForeignIpCountryParams;

  return (
    <>
      <Grid
        alignItems="baseline"
        size={{
          xs: 12,
          sm: 6,
          lg: 4,
        }}
      >
        <Box display="flex" flexDirection="column">
          <Box display="flex" flexDirection="row" gap={2} alignItems="center">
            <Typography sx={{ fontWeight: 'bold' }}>
              Lookback period
            </Typography>
          </Box>
          <Box display="flex" flexDirection="row" gap={2} alignItems="center" flexWrap="wrap">
            <Typography>{`${lookbackPeriod.amount} ${lookbackPeriod.unit}`}</Typography>
          </Box>
        </Box>
      </Grid>
      <Grid
        alignItems="baseline"
        size={{
          xs: 12,
          sm: 6,
          lg: 4,
        }}
      >
        <Box display="flex" flexDirection="column">
          <Box display="flex" flexDirection="row" gap={2} alignItems="center">
            <Typography sx={{ fontWeight: 'bold' }}>
              Expected countries
            </Typography>
          </Box>
          <Box display="flex" flexDirection="row" gap={2} alignItems="center" flexWrap="wrap">
            <Typography>
              {expectedCountries.map((country) => countries.getName(country, languages.EN)).join(', ')}
            </Typography>
          </Box>
        </Box>
      </Grid>
    </>
  );
};

export default SustainedForeignIpCountry;
